import { combineReducers } from '@reduxjs/toolkit';
import certificateReducer from './certificate.slice';
import badgeReducer from './badge.slice';
import competitionWinsReducer from './competition-wins.slice';

export const showcaseRootReducer = combineReducers({
    certificate: certificateReducer,
    badge: badgeReducer,
    competition: competitionWinsReducer,
});
